// Relative-time formatting for in-session events. Pure; no timers — callers
// re-render on state changes, which re-evaluates this opportunistically.
export function relTime(ts) {
  if (typeof ts !== 'number' || !Number.isFinite(ts)) return ''
  const secs = Math.max(0, Math.round((Date.now() - ts) / 1000))
  if (secs < 45) return 'just now'
  const mins = Math.round(secs / 60)
  if (mins < 60) return `${mins} min ago`
  const hrs = Math.round(mins / 60)
  if (hrs < 24) return `${hrs} hr ago`
  const days = Math.round(hrs / 24)
  return `${days} day${days === 1 ? '' : 's'} ago`
}
